import { StanInput } from '@/components';
import { Controller, useFormContext } from 'react-hook-form';
import type { ProfileFormValues } from '../validations/profileSchema';

interface BasicInfoSectionProps {
    disabled?: boolean;
}

export function BasicInfoSection({ disabled = false }: BasicInfoSectionProps) {
    const {
        control,
        formState: { errors },
        watch,
    } = useFormContext<ProfileFormValues>();

    const bioCharacterLimit = 80;
    const bioValue = watch('bio') || '';
    const bioCharacterCount = bioValue.length;
    const bioHintText = `${bioCharacterCount}/${bioCharacterLimit} characters${errors.bio?.message ? ` • ${errors.bio.message}` : ''}`;

    return (
        <div className='space-y-4'>
            <Controller
                name='displayName'
                control={control}
                render={({ field }) => (
                    <StanInput
                        id='display-name'
                        name={field.name}
                        topLabel='Display Name'
                        placeholder='Enter your display name'
                        value={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        disabled={disabled}
                        error={!!errors.displayName}
                        hintText={errors.displayName?.message}
                    />
                )}
            />

            <Controller
                name='bio'
                control={control}
                render={({ field }) => (
                    <StanInput
                        id='bio'
                        name={field.name}
                        placeholder='A short description of yourself...'
                        value={field.value || ''}
                        topLabel='Bio'
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        maxLength={bioCharacterLimit}
                        disabled={disabled}
                        error={!!errors.bio}
                        hintText={bioHintText}
                    />
                )}
            />
        </div>
    );
}
